import { trackInsight } from '@framework/appInsights';

import { useRuntimeContext } from '@components/pages/other/RuntimeContext/useRuntimeContext';

const useSendStatelessInsight = () => {
    const { APPLICATION_INSIGHTS_ENABLED, MIXPANEL_ENABLED } = useRuntimeContext();
    const sendInsight = (insightName: string, data?: { [key: string]: unknown }) => {
        return trackInsight({
            data,
            insightsEnabled: APPLICATION_INSIGHTS_ENABLED,
            mixpanelEnabled: MIXPANEL_ENABLED,
            name: insightName
        });
    };

    return sendInsight;
};

export default useSendStatelessInsight;
